import { computed, ref } from "vue";
import { EXPORT_FORMAT, type ExportFormatType } from "shared-utils/enums/exports";

const ftCampaignName = ref<string | undefined>(undefined);
const ftReferenceId = ref<string | undefined>(undefined);
const stripDimensionsFromVersionName = ref(false);

export function useDownloadFlashtalkingExcel() {
    const ftCampaignNameError = computed(() => {
        if (!ftCampaignName.value || ftCampaignName.value.trim().length === 0) {
            return "Required field";
        }
        return "";
    });

    const ftReferenceIdError = computed(() => {
        if (!ftReferenceId.value || ftReferenceId.value.trim().length === 0) {
            return "Required field";
        }
        if (!/^\d+$/.test(ftReferenceId.value.trim())) {
            return "Reference ID must be a number.";
        }
        return "";
    });

    const isButtonDisabled = computed<Partial<Record<ExportFormatType, boolean>>>(() => ({
        [EXPORT_FORMAT.FLASHTALKING_EXCEL]: ftCampaignNameError.value !== "" || ftReferenceIdError.value !== ""
    }));

    function resetDownloadOptions() {
        ftCampaignName.value = undefined;
        ftReferenceId.value = undefined;
        stripDimensionsFromVersionName.value = false;
    }

    function computeQueryParams(exportFormat: ExportFormatType) {
        if (exportFormat !== EXPORT_FORMAT.FLASHTALKING_EXCEL) {
            return {};
        }

        return {
            flashtalkingCampaignName: ftCampaignName.value,
            flashtalkingCampaignId: Number(ftReferenceId.value),
            flashtalkingRemoveVersionNameDimensions: stripDimensionsFromVersionName.value
        };
    }

    return {
        ftCampaignName,
        ftReferenceId,
        stripDimensionsFromVersionName,
        ftCampaignNameError,
        ftReferenceIdError,

        // computed
        isButtonDisabled,

        // methods
        resetDownloadOptions,
        computeQueryParams
    };
}
